<template>

  <t-page>

    <StepActionDialog @onSubmit="onSubmitStepAction" :type="modalActionType"
                      :production-order-batch-step-id="modalActionStepId"/>

    <StepCopyDataDialog :primary-key="form.productionOrderBatchStepId" @onSubmit="onSubmitStepCopy"/>


    <t-page-form tabs submit-bottom :submit-text="titleSubmit"
                 :title="titlePage"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 id-tab="containerFormStepTab"
                 :class-tab="{'col-lg-8':true, 'col-md-6':true,'col-sm-12':true}"
                 :go-back-title="t('go-back-list')" :go-back-path="currentPage.path" :busy="!pageFormIsLoaded"
                 submit-text-not-default>


      <template #default="{status}">


        <t-form-tab title="Etapa Atual">

          <b-card-title>{{ titleHeader }}</b-card-title>

          <slot name="header">

            <b-row>

              <t-input cols="4" highlight v-model="form.productionOrderCodeLabel" fixed label="Código"></t-input>

              <t-input cols="4" v-model="form.groupProduct" fixed label="Grupo"></t-input>

              <t-input cols="4" v-model="form.unitFull" fixed label="Embalagem"></t-input>

            </b-row>

            <b-row class="mb-2">

              <t-input cols="4" v-model="form.producedWeight" number fixed label="Peso do Bag (Kg)"></t-input>

              <t-input cols="4" v-model="form.model" fixed label="Preparação"></t-input>

              <t-input cols="4" v-model="form.shotLastStart" datetime fixed label="Data Início"></t-input>

            </b-row>


          </slot>


          <b-card-title>ETAPA ATUAL: {{ form.name }}</b-card-title>

          <b-row>

            <b-col cols="12">

              <t-input v-model="form.productionOrderBatchStepId" hidden/>


              <div class="d-flex align-items-end justify-content-end" v-if="form.enableCopyOtherStep">
                <b-link @click="openDialogForm('modal-copy-data-other-step')">
                  <b-icon-files class="mr-2"/>
                  Copiar dados
                </b-link>
              </div>


              <t-page-form-field-customized
                  ref="fieldsGeneral"
                  :command="command" :status="status" :user-auth="userAuth"
                  :fields-customizable="entityFieldCustomized('processFlowStep')"
                  :primary-key="form.productionOrderBatchStepId" :foreign-key="form.processFlowStepId"
                  :busy="!pageFormIsLoaded"
                  primary-key-column="productionOrderBatchStepId" foreign-key-column="processFlowStepId"
              />

              <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

            </b-col>

          </b-row>

        </t-form-tab>

      </template>

      <template #after-tabs>
        <b-col class="col-lg-4 col-md-6 col-sm-12">
          <ProductionBatchFlow :busy="!pageFormIsLoaded" origin-step-form :current-page="currentPage"
                               :max-height-steps="maxHeightSteps"
                               :enable-change-status-operation="relationAccessSubValidation('sub-production-step-change-operation-status')"
                               :production-order-batch-id="form.productionOrderBatchId"/>
        </b-col>
      </template>

      <template #out-of-form>

        <t-form-tab title="Imagens" hash="image" lazy>
          <ProductionOrderStepFile type-image :foreign-key="form[fieldKey]"/>
        </t-form-tab>

      </template>

      <template #footer>

        <t-button @click="stepAction(StepActionType.type.START,form.productionOrderBatchStepId)"
                  :sending="status === 'sending'"
                  v-if="form.statusExecution === StepExecutionType.type.WAITING"
                  primary>Iniciar Etapa
        </t-button>

        <div v-if="form.statusBatch === StatusProductionOrderType.type.PRODUCTION">

          <t-button warning @click="openModalActionStep('return')"
                    v-if="relationAccessSubValidation('sub-production-step-enable-return')"
                    :sending="status === 'sending'"
                    text="Alterar Etapa" class="ml-3"/>
          <t-button danger @click="openModalActionStep('stop')"
                    :sending="status === 'sending'"
                    v-if="relationAccessSubValidation('sub-production-step-enable-stop')"
                    text="Parar Produção" class="ml-3"/>

        </div>

        <div v-else-if="form.statusBatch === StatusProductionOrderType.type.STOPPED_PRODUCTION">

          <t-button primary @click="openModalActionStep('cancel_stop')"
                    :sending="status === 'sending'"
                    v-if="relationAccessSubValidation('sub-production-step-enable-stop')"
                    text="Continuar Produção" class="ml-3"/>

        </div>


        <!--        <t-button v-b-modal:modal-conteudo-tecnico text="Conteúdo Técnico"/>-->
      </template>

    </t-page-form>


  </t-page>

</template>
<script>
import ui from "@/assets/scripts/ui"

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ProductionOrderStepService from "@/services/modules/production/ProductionOrderStep.service";
import StepExecutionType from "@/model/types/modules/production/StepExecutionType";
import StepActionType from "@/model/types/modules/production/StepActionType";
import StepActionDialog from "@/views/modules/production/ProductionOrder/components/StepActionDialog";
import StepCopyDataDialog from "@/views/modules/production/ProductionOrder/components/StepCopyDataDialog";
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";
import ProductionOrderStepFile from "@/views/modules/production/ProductionOrder/ProductionOrderStepFile";
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";
import FlowStepRuleActionType from "@/model/types/modules/production/FlowStepRuleActionType";
import ProductionBatchFlow from "@/views/modules/production/ProductionOrder/ProductionBatchFlow";


export default {
  components: {StepActionDialog, StepCopyDataDialog, ProductionOrderStepFile, ProductionBatchFlow},
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],
  name: 'ProductionOrderStepFormEmbeddable',
  data() {
    return {
      StepExecutionType,
      StepActionType,
      StatusProductionOrderType,
      FlowStepRuleActionType,
      path: "production/order-step", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      fieldKey: "productionOrderBatchStepId",
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      fieldsCustomizable: [
        {
          entity: "processFlowStep",
          foreignKeyColumn: "processFlowStepId",
          path: "production/process-flow-step",
          fields: [],
        }
      ],
      modalActionType: '',
      modalActionStepId: 0,
      maxHeightSteps: '',
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    titlePage: {
      type: String,
      default: "Ordem de Fabricação em Andamento", //Padrão de página para redirecionar após operações
    },
    titleHeader: {
      type: String,
      default: "Dados da Ordem", //Padrão de página para redirecionar após operações
    },
    titleSubmit: {
      type: String,
      default: "Finalizar Etapa", //Padrão de página para redirecionar após operações
    },
  },
  methods: {

    async onSubmit() {

      if (this.enabledSubmit) {
        await this.sendingForm()
      } else {
        await this.$emit("beforeSubmit")
      }

    },

    mountedPrepare() {
      this.mountedPrepareEmbeddable()
    },
    async mountedContinued() {


      //Verifica se possui acesso para Iniciar ou Finalizar Etapa
      if (
          this.form.statusExecution === StepExecutionType.type.WAITING ||
          this.form.statusBatch !== StatusProductionOrderType.type.PRODUCTION
      ) {
        //Deverá iniciar a etapa para realização de alteração
        if (this.form.stepSequential || (!this.form.stepSequential && this.form.typeActionNotSequential !== 6)) {
          this.command = 'view'
        }

      }


      /*/!*Monta a listagem para realização de ações de retorno ou parada, caso o usuário possuir uma das validações a seguir *!/
      if (this.relationAccessSubValidation('sub-production-step-enable-return') ||
          this.relationAccessSubValidation('sub-production-step-enable-stop')) {


       console.log('ok')

      }*/
      await this.mountedContinuedEmbeddable() //Deixar sempre no final

      let height = document.getElementById('containerFormStepTab').offsetHeight;


      if (height > 0) {

        //Desconta o Status operacional mais margem
        height -= 200;

        this.maxHeightSteps = height + 'px'
      }


    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async sendingForm() {

      this.status = "sending"

      //Verifica se alguma regra será aplicada
      await this.injectFieldsForm()


      await ProductionOrderStepService.checkRules(
          this,
          this.form,
          this.onSubmitContinued,
          this.sendingForm,
          () => {
            this.status = ""
          },
          (alternativeChosen) => {
            this.form.alternativeChosen = alternativeChosen
          },
          (typeNonConformanceChosen) => {
            this.form.typeNonConformanceChosen = typeNonConformanceChosen
          },
      )
    },

    onSubmitStepAction(action) {

      this.goPath(this.currentPage.path, {
        codSuccess: 100,
        returnMessage: 'Etapa ' + action.text + ' ' + StepActionType.getReturnMessage(action.value) + ' com sucesso!'
      })
    },

    async onSubmitStepCopy(step) {

      //Troca os campos pela etapa que deseja copiar
      this.form.fieldsCustomized = step.fieldsCustomized

      //Copia os dados de observações
      this.form.note = step.note

      //Obtem todos os campos e injeta os campos copiados.
      await this.getAllFieldsCustomizable();


      //Informa que foi copiado com sucesso
      ui.toast(this, "Informação", "Dados copiados com sucesso!")

    },

    openModalActionStep(type) {

      this.modalActionType = type
      this.modalActionStepId = this.form.productionOrderBatchStepId
      this.openDialogForm('modal-action-step')

    },

    async onSubmitContinued() {
      await this.sendingFormDefault()
    },

    async stepAction(type_action, id, goProductionOrderBatchStepId, typeStopId, stopNote) {

      await ProductionOrderStepService.action(type_action, id, goProductionOrderBatchStepId, typeStopId, stopNote).then(() => {

        if (type_action === StepActionType.type.START) {
          //Habilita formulário para alteração
          this.$emit("reload")
        } else {
          this.goPath(this.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Etapa ' + this.form.name + ' ' + StepActionType.getReturnMessage(type_action) + ' com sucesso!'
          })
        }

      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(false, true)

    await this.mountedContinued()

  },
}
</script>
